/**
 * AiSLSiteHeaderLanguagesView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait AiSLSiteHeaderLanguages
 */

import { useAiSLSiteHeaderLanguagesLogic } from '@/hooks/traits/useAiSLSiteHeaderLanguagesLogic';
import type { AiSLSiteHeaderLanguagesConfig } from '@/hooks/traits/useAiSLSiteHeaderLanguagesLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { AiSLAiView as AiSLAiViewEntity } from '@app/shared';
import { Menu } from '@almadar/ui/components';
import { Button } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';
import { useTranslate } from '@almadar/ui/hooks';

interface AiSLSiteHeaderLanguagesViewProps {
  config?: Partial<AiSLSiteHeaderLanguagesConfig>;
}

export function AiSLSiteHeaderLanguagesView({ config: propsConfig }: AiSLSiteHeaderLanguagesViewProps) {
  const { t: __t, locale: __locale } = useTranslate();
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useAiSLSiteHeaderLanguagesLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['AiSLAiView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="AiSL" trait="AiSLSiteHeaderLanguages">
      {slotWriter['main'] === 'INIT' ? (<Menu trigger={<Button variant="ghost" label={String(__locale.toUpperCase())} size="sm" icon="globe" />} items={Array.isArray(([{ code: "en" as const, label: "English" as const, href: "/ai" as const }, { label: "العربية" as const, href: "/ar/ai" as const, code: "ar" as const }, { code: "sl" as const, href: "/sl/ai" as const, label: "Slovenščina" as const }]).map((entry) => ({ href: (getNestedValue(entry, "href") ?? ""), label: (getNestedValue(entry, "label") ?? ""), icon: (((getNestedValue(entry, "code") ?? "") === __locale) ? "check" : ""), id: (getNestedValue(entry, "code") ?? "") }))) ? (((([{ code: "en" as const, label: "English" as const, href: "/ai" as const }, { label: "العربية" as const, href: "/ar/ai" as const, code: "ar" as const }, { code: "sl" as const, href: "/sl/ai" as const, label: "Slovenščina" as const }]).map((entry) => ({ href: (getNestedValue(entry, "href") ?? ""), label: (getNestedValue(entry, "label") ?? ""), icon: (((getNestedValue(entry, "code") ?? "") === __locale) ? "check" : ""), id: (getNestedValue(entry, "code") ?? "") }))) as EntityRow[]) as ({ badge?: string | number; disabled?: boolean; event?: string; href?: string; icon?: string; id?: string; label: string; onClick?: never; subMenu?: never[]; title?: string; type?: 'item' | 'divider'; url?: string; variant?: 'default' | 'danger' })[]) : []} position="bottom-end" className={((([{ label: "English" as const, code: "en" as const, href: "/ai" as const }, { label: "العربية" as const, href: "/ar/ai" as const, code: "ar" as const }, { code: "sl" as const, label: "Slovenščina" as const, href: "/sl/ai" as const }]).length === 0)) ? "hidden" : ""} />) : null}
    </TraitScopeProvider>
  );
}

export default AiSLSiteHeaderLanguagesView;
